import webApi from "@/services/api";
import store from "@/store";
import systemConfigService from "@/services/system-config";
import { getParamFromURL } from "@/helper/utils";

export class TopPageService {
  authenticateSeller(data) {
    return webApi.post("lead-update-service/auth", data);
  }
  searchRedbookRego(data) {
    return webApi.post("car-detail/rego-redbook-api", data);
  }
  searchAutograbRego(data) {
    return webApi.post("car-detail/rego-autograb-api", data);
  }
  async searchRego(data) {
    // Get system configuration to determine vehicle data source
    let vehicleDataSource = store.getters.systemConfigurations.vehicleDataSource;
    
    if (!vehicleDataSource) {
      try {
        const locid = data.locid || getParamFromURL(window.location.href, "locid");
        const params = locid ? { locid } : {};
        const systemConfigResult = await systemConfigService.getSystemConfig(
          params
        );
        vehicleDataSource =
          systemConfigResult.status === 200 &&
          systemConfigResult.data.vehicleDataSource
            ? systemConfigResult.data.vehicleDataSource
            : null;
      } catch (error) {
        console.error('Failed to get system configurations:', error);
        return this.searchRedbookRego(data);
      }
    }

    // Check if activeSource is RB, then use searchRedbookRego
    if (vehicleDataSource?.activeSource === "RB") {
      return this.searchRedbookRego(data);
    }
    // Check if activeSource is AG, then use searchAutograbRego
    else if (vehicleDataSource?.activeSource === "AG") {
      return this.searchAutograbRego({
        regoNumber: data.regoNumber,
        locid: data.locid,
      });
    }
    // Default fallback to redbook API
    else {
      return this.searchRedbookRego(data);
    }
  }
}

const topPageService = new TopPageService();

export default topPageService;
